import { Token } from "@lib/tokens";

export const CONSTANTS: Partial<Record<Token, number>> = {
    // TODO: add a mode for using updated CODATA values instead of faithfully emulating the original ROM
    [Token.PROTON_MASS]: 1.672621777e-27,
    [Token.NEUTRON_MASS]: 1.674927351e-27,
    [Token.ELECTRON_MASS]: 9.10938291e-31,
    [Token.MUON_MASS]: 1.883531475e-28,
    [Token.BOHR_RADIUS]: 5.2917721092e-11,
    [Token.PLANCK_CONSTANT]: 6.62606957e-34,
    [Token.NUCLEAR_MAGNETON]: 5.05078353e-27,
    [Token.BOHR_MAGNETON]: 9.27400968e-24,
    [Token.PLANCK_CONSTANT_REDUCED]: 1.054571726e-34,
    [Token.FINE_STRUCTURE_CONSTANT]: 7.2973525698e-3,
    [Token.CLASSICAL_ELECTRON_RADIUS]: 2.8179403267e-20,
    [Token.ELECTRON_COMPTON_WAVELENGTH]: 2.4263102389e-12,
    [Token.PROTON_GYROMAGNETIC_RATIO]: 2.675222005e8,
    [Token.PROTON_COMPTON_WAVELENGTH]: 1.32140985623e-19,
    [Token.NEUTRON_COMPTON_WAVELENGTH]: 1.3195909068e-20,
    [Token.RYDBERG_CONSTANT]: 1.0973731568539e7,
    [Token.ATOMIC_MASS_CONSTANT]: 1.660538921e-27,
    [Token.PROTON_MAGNETIC_MOMENT]: 1.410606743e-33,
    [Token.ELECTRON_MAGNETIC_MOMENT]: -9.2847643e-24,
    [Token.NEUTRON_MAGNETIC_MOMENT]: -9.6623647e-27,
    [Token.MUON_MAGNETIC_MOMENT]: -4.49044807e-26,
    [Token.FARADAY_CONSTANT]: 9.64853365e4,
    [Token.ELEMENTARY_CHARGE]: 1.602176565e-19,
    [Token.AVOGADRO_CONSTANT]: 6.02214129e23,
    [Token.BOLTZMANN_CONSTANT]: 1.3806488e-23,
    [Token.MOLAR_VOLUME_OF_IDEAL_GAS]: 2.2710953e-2,
    [Token.MOLAR_GAS_CONSTANT]: 8.3144621,
    [Token.SPEED_OF_LIGHT_IN_VACUUM]: 2.99792458e8,
    [Token.FIRST_RADIATION_CONSTANT]: 3.74177153e-16,
    [Token.SECOND_RADIATION_CONSTANT]: 1.438777e-2,
    [Token.STEFAN_BOLTZMANN_CONSTANT]: 5.670373e-8,
    [Token.VACUUM_PERMITTIVITY]: 8.854187817e-12,
    [Token.VACUUM_PERMEABILITY]: 1.2566370614e-6,
    [Token.MAGNETIC_FLUX_QUANTUM]: 2.067833758e-15,
    [Token.STANDARD_ACCERLATION_OF_GRAVITY]: 9.80665,
    [Token.CONDUCTANCE_QUANTUM]: 7.7480917346e-5,
    [Token.CHARACTERISTIC_IMPEDANCE_OF_VACUUM]: 3.76730313461e2,
    [Token.KELVIN_CELSIUS_SCALE_OFFSET]: 2.7315e2,
    [Token.GRAVITATIONAL_CONSTANT]: 6.67384e-11,
    [Token.STANDARD_ATMOSPHERE]: 1.01325e5,
}